import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

const CONTROLLER = "Macrohard1 SRL, Strada Comunale Val San Martino 111 - 10131 Torino, P.IVA 13389550016, email: info@macrohard.it";

const DOCS = {
  privacy: {
    title: "Informativa sulla privacy",
    sections: [
      ["Titolare del trattamento", `Il titolare del trattamento è ${CONTROLLER}.`],
      ["Quali dati trattiamo", "Dati di account forniti da Google (nome, email, foto profilo); dati che inserisci tu: scadenze, profili familiari (es. nome, codice fiscale, data di nascita), documenti caricati e loro analisi, lettere, conversazioni con l'assistente; dati di pagamento gestiti da Stripe (Burocrazy non conserva i dati della carta); log tecnici di sicurezza."],
      ["Finalità e base giuridica", "Fornire il servizio richiesto (art. 6.1.b GDPR, esecuzione del contratto); invio dei promemoria email che puoi disattivare; adempimenti fiscali per i pagamenti (art. 6.1.c); comunicazioni promozionali solo con il tuo consenso (art. 6.1.a), revocabile in ogni momento. Se carichi documenti contenenti dati sanitari (es. verbali di invalidità) il trattamento avviene sulla base del tuo consenso esplicito (art. 9.2.a) e al solo scopo di erogarti il servizio."],
      ["Intelligenza artificiale", "Il contenuto dei documenti che scegli di analizzare e i messaggi della chat sono inviati a un fornitore di modelli di intelligenza artificiale al solo fine di generare la risposta. Le risposte hanno valore orientativo e non sostituiscono un professionista."],
      ["Responsabili e destinatari", "Fornitori di hosting e archiviazione, fornitore del modello AI, Stripe (pagamenti), servizio di invio email. Alcuni fornitori possono trovarsi fuori dallo Spazio Economico Europeo: in tal caso il trasferimento avviene con garanzie adeguate (Clausole Contrattuali Standard)."],
      ["Conservazione", "I dati sono conservati finché mantieni l'account. Cancellando l'account dalle Impostazioni i tuoi dati vengono eliminati, salvo quelli che dobbiamo conservare per obblighi di legge (es. dati di fatturazione)."],
      ["I tuoi diritti", "Accesso, rettifica, cancellazione, limitazione, portabilità e opposizione (artt. 15-22 GDPR). Dalle Impostazioni puoi esportare tutti i tuoi dati in formato JSON e cancellare l'account in autonomia. Puoi proporre reclamo al Garante per la protezione dei dati personali (garanteprivacy.it)."],
      ["Sicurezza", "Connessioni cifrate HTTPS, cookie di sessione httpOnly e sicuri, accesso ai documenti consentito solo al proprietario, limiti di dimensione e tipo dei file caricati."],
    ],
  },
  cookie: {
    title: "Cookie policy",
    sections: [
      ["Cookie tecnici", "Usiamo solo il cookie di sessione 'session_token', necessario per mantenerti connesso (durata 7 giorni). Non richiede consenso ai sensi dell'art. 122 del Codice Privacy."],
      ["Archiviazione locale", "Salviamo nel browser solo la conferma di aver letto il banner cookie."],
      ["Cookie di terze parti", "Non usiamo cookie di profilazione né pubblicitari. Durante il pagamento Stripe può impostare cookie tecnici propri, necessari a prevenire frodi."],
      ["Titolare", CONTROLLER],
    ],
  },
  termini: {
    title: "Termini di servizio",
    sections: [
      ["Il servizio", "Burocrazy è uno strumento di organizzazione e orientamento per pratiche amministrative. Non è un CAF, un patronato né uno studio professionale e non presta consulenza fiscale, legale o previdenziale."],
      ["Responsabilità", "Le informazioni e le risposte generate dall'AI possono contenere errori. Verifica sempre importi, scadenze e requisiti sui portali ufficiali o con un professionista prima di agire."],
      ["Account", "Accedi con il tuo account Google. Sei responsabile dei contenuti che carichi e devi avere titolo a caricare documenti di familiari."],
      ["Piano Pro", "Il piano Pro costa 9,99 € al mese, si rinnova automaticamente e può essere disdetto in qualsiasi momento dalle Impostazioni; resta attivo fino alla fine del periodo pagato. Per i consumatori si applica il diritto di recesso di 14 giorni previsto dal Codice del Consumo."],
      ["Uso corretto", "È vietato usare il servizio per attività illecite, per inviare comunicazioni ingannevoli o per caricare contenuti di terzi senza autorizzazione."],
      ["Fornitore", CONTROLLER],
    ],
  },
};

export default function Legal({ kind }) {
  const doc = DOCS[kind];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [kind]);
  return (
    <div className="min-h-screen" data-testid={`legal-${kind}`}>
      <header className="border-b bg-white/70 backdrop-blur-xl sticky top-0">
        <div className="max-w-4xl mx-auto px-5 h-16 flex items-center justify-between">
          <Logo />
          <Link to="/" className="text-sm flex items-center gap-1 text-slate-600 hover:text-slate-900" data-testid="legal-back-link"><ArrowLeft className="h-4 w-4" /> Home</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-16">
        <h1 className="text-4xl font-semibold tracking-tight">{doc.title}</h1>
        <p className="mt-2 text-sm text-slate-500">Versione 1.0 · ultimo aggiornamento ottobre 2026</p>
        <div className="mt-10 space-y-8">
          {doc.sections.map(([h, t]) => (
            <section key={h}>
              <h2 className="text-xl font-medium">{h}</h2>
              <p className="mt-2 text-slate-700 leading-relaxed">{t}</p>
            </section>
          ))}
        </div>
        <div className="mt-12 flex gap-4 text-sm">
          <Link to="/privacy" className="underline">Privacy</Link>
          <Link to="/cookie" className="underline">Cookie</Link>
          <Link to="/termini" className="underline">Termini</Link>
        </div>
      </main>
    </div>
  );
}
